const { bookDefaultImage, productImageUrl } = require('../../../applicationProperties.json');

if($('.js--recently-view').length) {
    let RECENTLY_VIEW_PRODUCTS_QUEUE = JSON.parse(localStorage.getItem('_rVP')) || [];

    if (RECENTLY_VIEW_PRODUCTS_QUEUE.length > 0) {
        let recentlyViewHtml = "";
        RECENTLY_VIEW_PRODUCTS_QUEUE.forEach(product => {
            recentlyViewHtml += `<div class="slick-item-wrapper">
                                    <div class="recently-view__img">
                                        <a href="/book/${product.pdi}">
                                            <img class="img-fluid" src="${bookDefaultImage}" data-src="${productImageUrl}/130X186/${product.pmi}" alt="${product.pna} image" />
                                        </a>
                                    </div>
                                </div>`;
        });
    
        $('.js--recently-view').html(recentlyViewHtml);
        $('.recently-viewed-section').show();
    } 
}